import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchRetentionRateByAdCapping } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function UserFrequencyCappingImpact() {
  const tableRef = useRef(null);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const getRetentionRateByAdCapping = async () => {
    const res = await fetchRetentionRateByAdCapping();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (selectedUserType?.length) {
        const temp = res?.data?.data?.filter(
          (f) => f.User_Type === selectedUserType
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    }
  };

  const handleFIlters = (str) => {
    setSelectedUserType(str);
    if (str?.length) {
      const temp = tableData?.filter((f) => f.User_Type === str);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedUserType("");
    setFilteredData(tableData);
  };

  const chartData = {
    labels: filteredData.map(
      (item) => `${item?.User_Type} (${item?.Frequency_Capping})`
    ),
    datasets: [
      {
        label: "Retention Rate (%)",
        data: filteredData.map((item) => item?.Retention_Rate),
        backgroundColor: "rgba(255, 206, 86, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getRetentionRateByAdCapping();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item?.Frequency_Capping, item.User_Type, item.Retention_Rate];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Frequency Capping" },
        { title: "User Type" },
        { title: "Retention Rate (%)" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedUserType}
                onChange={(e) => handleFIlters(e.target.value)}
              >
                <option value="">All user types</option>
                <option value="Guest">Guest</option>
                <option value="Registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">User Frequency Capping Impact</h5>
          <p className="card-text">
            Analyzing this data can help you identify Does limiting ads per
            session improve retention?
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Retention Rate by Frequency Capping</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default UserFrequencyCappingImpact;
